import { render, staticRenderFns } from "./CharitiesList.vue?vue&type=template&id=736d8aed"
import script from "./CharitiesList.vue?vue&type=script&lang=js"
export * from "./CharitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports